import { Link } from "react-router-dom";

const values = [
  {
    icon: "ri-heart-line",
    title: "For Real People",
    desc: "No PhD required. We translate the complex into plain English for working people, parents, and business owners.",
  },
  {
    icon: "ri-seedling-line",
    title: "Grounded in Faith",
    desc: "We believe technology must serve humanity, not replace it. Our conversations are anchored in values that matter.",
  },
  {
    icon: "ri-lightbulb-line",
    title: "Honest & Clear",
    desc: "No hype, no fear-mongering. Just clear, honest conversations about what AI means for your everyday life.",
  },
];

export default function AboutPreview() {
  return (
    <section className="bg-cream py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image side */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/c33569f096ac9bcb383f5a475c3cde76.jpg"
                alt="Host of The Humble Machine"
                className="w-full h-[500px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-amber-900/40 to-transparent" />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-4 lg:-right-8 bg-white rounded-2xl border border-amber-100 p-5 max-w-[220px]">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-amber-100">
                  <i className="ri-headphone-line text-amber-700 text-lg" />
                </div>
                <div>
                  <p className="font-sans text-xs text-stone-400">Total Listeners</p>
                  <p className="font-serif font-bold text-amber-800 text-xl">0</p>
                </div>
              </div>
              <p className="font-sans text-xs text-stone-500 leading-relaxed">
                And growing every week — from all walks of life
              </p>
            </div>
            {/* Decorative ring */}
            <div className="absolute -top-4 -left-4 w-24 h-24 rounded-full border-4 border-amber-300/40" />
          </div>

          {/* Text side */}
          <div>
            <span className="font-sans text-xs font-semibold tracking-widest uppercase text-amber-600 block mb-4">
              About the Show
            </span>
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-amber-900 leading-tight mb-6">
              AI for Real People,<br />
              <em className="text-amber-600">Real Lives</em>
            </h2>
            <p className="font-sans text-base text-stone-600 leading-relaxed mb-5">
              The Humble Machine exists because too many people feel left behind by the AI conversation.
              The headlines are scary. The tech world speaks a different language. And most podcasts are
              made <strong>by</strong> tech insiders, <strong>for</strong> tech insiders.
            </p>
            <p className="font-sans text-base text-stone-600 leading-relaxed mb-8">
              This one is different. Every conversation is designed to help you — the business owner,
              the parent, the person of faith — understand what AI means for your world, your work,
              and your family.
            </p>

            {/* Values */}
            <div className="space-y-5 mb-10">
              {values.map((v) => (
                <div key={v.title} className="flex items-start gap-4 p-4 rounded-xl hover:bg-amber-50 transition-colors duration-200 cursor-default group">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-amber-100 group-hover:bg-amber-200 flex-shrink-0 mt-0.5 transition-colors duration-200">
                    <i className={`${v.icon} text-amber-700 text-base`} />
                  </div>
                  <div>
                    <h3 className="font-sans font-semibold text-amber-900 text-sm mb-1">{v.title}</h3>
                    <p className="font-sans text-sm text-stone-500 leading-relaxed">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 active:scale-95 text-amber-950 font-sans font-bold text-sm px-7 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Meet Your Host
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
